import React, { useState } from 'react';
import { Link as LinkScroll } from 'react-scroll';
import List from '@material-ui/core/List';
import Hidden from '@material-ui/core/Hidden';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AuthButton from '../../../Buttons/AuthButton';
import Collapse from '@material-ui/core/Collapse';
import Session from '../../Session/';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import * as ROUTES from '../../../../routes';
import { useRouteMatch } from 'react-router-dom';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    height: 'fit-content',
    backgroundColor: '#013957',
  },
  columnList: {
    flexFlow: 'column',
    width: 'auto',
    backgroundColor: '#013957',
    color: 'white',
  },
  buttonItem: {
    height: 56,
    position: 'relative',
    '&::after': {
      border: '1px solid white',
      height: 1,
      width: '90%',
      opacity: 0.15,
      display: 'block',
      position: 'absolute',
      clear: 'both',
      content: "''",
      right: 0,
      marginTop: 28,
    },
  },
  buttonItemOpen: {
    height: 56,
  },
  itemSession: {
    height: 88,
    position: 'relative',
    marginBottom: 0,
    paddingLeft: 24,
    '&::after': {
      border: '1px solid white',
      height: 1,
      width: '90%',
      opacity: 0.15,
      display: 'block',
      position: 'absolute',
      clear: 'both',
      content: "''",
      right: 0,
      //marginTop: 28,
      bottom: 0,
    },
  },
  itemText: {
    marginLeft: 14,
    color: 'white',
  },
  buttonList: {
    display: 'block',
    // justifyContent: 'center',
  },
  buttonContainer: {
    padding: '40px 8px 32px',
    display: 'flex',
    justifyContent: 'center',
  },
  buttonSign: {
    width: 144,
    height: 40,
    color: '#013957',
    borderRadius: '30px',
    border: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    '@media (max-width: 1359px)': {
      backgroundColor: 'white',
    },
    '&:hover': {
      backgroundColor: '#35b9b6',
      color: 'white'
    }
  },
  buttonLogin: {
    width: 144,
    height: 40,
    backgroundColor: 'transparent',
    borderColor: 'white',
    fontSize: 16,
    borderRadius: 30,
    marginRight: 0,
    marginTop: 24,
  },
  listAuth: {
    position: 'relative',
    '&::after': {
      border: '1px solid white',
      height: 1,
      width: '90%',
      opacity: 0.15,
      display: 'block',
      position: 'absolute',
      clear: 'both',
      content: "''",
      right: 0,
      //marginTop: 28,
      bottom: 0,
    },
  },
  listItem1: {
    backgroundColor: '#013957',
    width: 240,
    padding: '14px 16px',
    '&:hover': {
      backgroundColor: '#013957',
    },
  },
  listItem2: {
    backgroundColor: '#013957',
    width: 240,
    '&:focus': {
      backgroundColor: '#013957',
    },
    '&:hover': {
      backgroundColor: '#013957',
    },
  },
  itemText2: {
    color: 'white',
    maxWidth: 'fit-content',
    '& span': {
      fontSize: 16,
      fontWeight: 900,
    },
  },
  itemText3: {
    color: 'white',
    '& span': {
      fontSize: 15,
      whiteSpace: 'nowrap',
      padding: '0 0 0 20px',
    },
  },
  linkStyle: {
    textDecoration: 'none',
    outline: 'none',
    color: 'unset'
  }
}));

const MenuDrawer = ({ hideDrawer, sections, userdata }) => {
  const classes = useStyles();
  const landingLawyers = useRouteMatch(ROUTES.LANDING_PAGE);
  const [open, setOpen] = useState(false);
 
  const handleClick = button => (event ) => {
    if(button === 'signup'){
      setOpen(open ==='signup'? false: 'signup');
    }else if(button === 'login') {
      setOpen(open ==='login'? false: 'login')
    }
    
  };

  return (
    <div>
      <div className={classes.toolbar} />
      <List classes={{ root: classes.columnList }}>
        {userdata !== null && (
          <ListItem classes={{ root: classes.itemSession }}>
            <Session profile={userdata} inDrawer />
          </ListItem>
        )}

        {sections &&
          sections.map((section, index) => {
            return section.link === 'scroll' ? (
              <LinkScroll
                key={index}
                to={section.to}
                smooth="true"
                duration={section.duration}
                delay={100}
                offset={-50}
                href={`#${section.to}`}
                className={classes.linkStyle}
              >
                <ListItem
                  button
                  classes={{ root: classes.buttonItem }}
                  onClick={hideDrawer}
                >
                  <ListItemText
                    classes={{ root: classes.itemText }}
                    primary={section.name}
                  />
                </ListItem>
              </LinkScroll>
            ) : (
              <Link
                key={index}
                to={section.to}
                className={classes.linkStyle}
              >
                <ListItem button classes={{ root: classes.buttonItem }}>
                  <ListItemText
                    classes={{ root: classes.itemText }}
                    primary={section.name}
                  />
                </ListItem>
              </Link>
            );
          })}

        {userdata === null ? (
          <>
            <>
              <ListItem
                button
                classes={{
                  root: open === 'signup' ? classes.buttonItemOpen : classes.buttonItem,
                }}
                onClick={handleClick('signup')}
              >
                <ListItemText
                  primary="Regístrate"
                  classes={{ root: classes.itemText }}
                />
                {open === 'signup' ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open === 'signup'} timeout="auto" unmountOnExit>
                <List component="div" disablePadding classes={{root: classes.listAuth}}>
                 {/*  <ListItem
                    button
                    classes={{ root: classes.listItem1 }}
                    style={{ cursor: 'not-allowed', opacity: 0.5 }}
                  >
                    <ListItemText
                      primary="Registrarme como abogado"
                      classes={{ root: classes.itemText3 }}
                    />
                  </ListItem>
                  <ListItem
                    button
                    classes={{ root: classes.listItem1 }}
                    style={{ cursor: 'not-allowed', opacity: 0.5 }}
                  >
                    <ListItemText
                      primary="Registrarme como despacho"
                      classes={{ root: classes.itemText3 }}
                    />
                  </ListItem> */}
                  <ListItem button classes={{ root: classes.listItem1 }}>
                    <Link
                      to={ROUTES.SIGN_UP_CLIENT}
                      style={{
                        textDecoration: 'none',
                        color: 'unset',
                        outline: 'none',
                      }}
                    >
                      <ListItemText
                        primary="Registrarme como usuario"
                        classes={{ root: classes.itemText3 }}
                      />
                    </Link>
                  </ListItem>
                </List>
              </Collapse>
            </>

            <ListItem
              button
              classes={{
                root: open === 'login' ? classes.buttonItemOpen : classes.buttonItem,
              }}
              onClick={handleClick('login')}
            >
              <ListItemText
                primary="Inicia sesión"
                classes={{ root: classes.itemText }}
              />
              {open === 'login' ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open === 'login'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding classes={{root: classes.listAuth}}>
                <ListItem button classes={{ root: classes.listItem1 }}>
                  <Link
                    to={ROUTES.SIGN_IN_MAIN_CLIENT}
                    style={{
                      textDecoration: 'none',
                      color: 'unset',
                      outline: 'none',
                    }}
                  >
                    <ListItemText
                      primary="Inicia sesión usuario"
                      classes={{ root: classes.itemText3 }}
                    />
                  </Link>
                </ListItem>

                <ListItem button classes={{ root: classes.listItem1 }}>
                  <Link
                    to={ROUTES.SIGNIN}
                    style={{
                      textDecoration: 'none',
                      color: 'unset',
                      outline: 'none',
                    }}
                  >
                    <ListItemText
                      primary="Inicia sesión abogado"
                      classes={{ root: classes.itemText3 }}
                    />
                  </Link>
                </ListItem>
              </List>
            </Collapse>
            
            <div className={classes.buttonContainer}>
              <Link
                to={ROUTES.LANDING_PAGE_300}
                className={classes.buttonSign}
              >
                ¿Eres abogado?
              </Link>
            </div>
          </>
        ) : null}
      </List>
    </div>
  );
};

export default MenuDrawer;
